import React, { useState } from 'react';
import { Radar } from 'react-chartjs-2';
import downArrow from '../../../Assets/Images/down.svg';
import wideview from '../../../Assets/Images/wideView.svg';
import morebtn from '../../../Assets/Images/more-btn.svg';
import { Button } from '@mui/material';

export default function SentimentsRadar({ setTableViewOpen }) {
  const [selectedDatasets, setSelectedDatasets] = useState([
    'ALL (AVG)', 'EMPLOYED', 'RETIRED', 'STUDENT', 'STAY AT HOME', 'HOMEMAKER', 'CAREGIVER', 'VOLUNTEER', 'UNEMPLOYED'
  ]);

  const toggleDataset = (label) => {
    setSelectedDatasets(prevState =>
      prevState.includes(label)
        ? prevState.filter(item => item !== label)
        : [...prevState, label]
    );
  };

  const allData = {
    labels: ['#2.1', '#2.2', '#2.3', '#2.4', '#2.5', '#2.6'],
    datasets: [
      {
        label: 'ALL (AVG)',
        data: [65, 59, 90, 81, 56, 55],
        fill: true,
        backgroundColor: '#ACC5494D',
        borderColor: '#ACC549',
      },
      {
        label: 'EMPLOYED',
        data: [28, 48, 40, 19, 96, 27],
        fill: true,
        backgroundColor: '#97E7E780',
        borderColor: '#66D7DE',
      },
      {
        label: 'RETIRED',
        data: [41, 76, 71, 43, 42, 20],
        fill: true,
        backgroundColor: '#ACDCFF80',
        borderColor: '#6A9DFF',
      },
      {
        label: 'STUDENT',
        data: [39, 74, 20, 77, 29, 92],
        fill: true,
        backgroundColor: '#C5C4FF80',
        borderColor: '#836FFB',
      },
      {
        label: 'STAY AT HOME',
        data: [96, 5, 58, 34, 24, 9],
        fill: true,
        backgroundColor: '#F0C5FF80',
        borderColor: '#BA59E7',
      },
      {
        label: 'HOMEMAKER',
        data: [24, 7, 59, 87, 5, 48],
        fill: true,
        backgroundColor: '#FFC1E280',
        borderColor: '#DB4CB2',
      },
      {
        label: 'CAREGIVER',
        data: [55, 16, 94, 63, 57, 30],
        fill: true,
        backgroundColor: '#FFBFCA80',
        borderColor: '#F77DAA',
      },
      {
        label: 'VOLUNTEER',
        data: [38, 73, 42, 23, 28, 76],
        fill: true,
        backgroundColor: '#FFBDB480',
        borderColor: '#EA7369',
      },
      {
        label: 'UNEMPLOYED',
        data: [92, 36, 47, 76, 31, 19],
        fill: true,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: '#CCCCCC',
      },
    ],
  };

  const selectedData = {
    labels: allData.labels,
    datasets: allData.datasets.filter(dataset => selectedDatasets.includes(dataset.label))
  };

  const options = {
    plugins: {
      legend: {
        display: false // Hide the built-in legend
      },
      tooltip: {
        enabled: false,
      },
    },
    elements: {
      line: {
        borderWidth: 2,
      },
    },
    maintainAspectRatio: false,
    scales: {
      r: {
        ticks: {
          display: false,
        },
      },
    },
  };

  return (
    <div className='sentiments-chart'>
      <div className="header">
        <div className="left">
          <div className='heading'>By Employment Status</div>
          <img src={downArrow} alt="Down Arrow" />
        </div>
        <div className="right">
          <img src={wideview} onClick={() => setTableViewOpen(true)} alt="Wide View" />
          <img src={morebtn} alt="More Button" />
        </div>
      </div>
      <div className='radar-chart'>
        <div className="labels">
          {allData.datasets.map((item, index) => (
            <Button
              key={index}
              onClick={() => toggleDataset(item.label)}
              style={{
                cursor: 'pointer',
                backgroundColor: selectedDatasets.includes(item.label) ? item.backgroundColor : '#FFFFFF',
                marginBottom: '5px',
              }}
            >
              <div className='circle' style={{ backgroundColor: item.borderColor, marginRight: '8px', width: '12px', height: '12px', borderRadius: '50%' }}></div>
              {item.label}
            </Button>
          ))}
        </div>
        <div className="chart-area">
          <Radar data={selectedData} options={options} height={'219px'} width={'232px'} />
        </div>
      </div>
    </div>
  );
}
